import { render, staticRenderFns } from "./VendorSelector.vue?vue&type=template&id=038c9df8&scoped=true&"
import script from "./VendorSelector.vue?vue&type=script&lang=js&"
export * from "./VendorSelector.vue?vue&type=script&lang=js&"
import style0 from "./VendorSelector.vue?vue&type=style&index=0&id=038c9df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c9df8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038c9df8')) {
      api.createRecord('038c9df8', component.options)
    } else {
      api.reload('038c9df8', component.options)
    }
    module.hot.accept("./VendorSelector.vue?vue&type=template&id=038c9df8&scoped=true&", function () {
      api.rerender('038c9df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/pool/components/VendorSelector.vue"
export default component.exports